import {
  DoctorActivityResponseModel,
  DoctorProfileResponse,
  DoctorReviewsData,
  DoctorServiceTarifsDataModel,
  GetDoctorListDataModel,
  GetOnlineDoctorListPayloadModel,
  GetOnlineDoctorListResponseModel,
  GetOnlineSuggestedDoctorsPayload,
  GetOnlineSuggestedDoctorsResponse,
  GetSuggestedDoctorsPayload,
  GetSuggestedDoctorsResponse,
  NotifyOnlineDoctorPayload,
  NotifyOnlineDoctorResponse,
} from '@models/ocs/doctor';
import request from '@api/request';
import { buildQueryParams } from '@utilities/buildQueryParams';

export const getDoctorProfileServerSide = async (id: string) => {
  const response = await request.get(`/Doctors/GetDoctorById?Id=${id}`);
  return response.data;
};

export const getDoctorList = async (
  body: any,
): Promise<GetDoctorListDataModel> => {
  const query = buildQueryParams(body, {
    multiKeys: { Specialities: 'SubSpecialityId' },
  });
  const response: any = await request.get(
    `/Doctors/GetDoctorsBySpeciality?${query}`,
  );
  return response.data;
};

export const getOnlineDoctorsList = async (
  body: GetOnlineDoctorListPayloadModel,
): Promise<GetOnlineDoctorListResponseModel> => {
  const query = buildQueryParams(body, {
    delimiter: '-',
    multiKeys: {
      SubSpecialityId: 'SubSpecialityId',
    },
  });
  const response = await request.get(`/Doctors/GetOnlineDoctors?${query}`);
  return response.data;
};

export const getSuggestedDoctorList = async (
  body: GetSuggestedDoctorsPayload,
): Promise<GetSuggestedDoctorsResponse> => {
  const response: any = await request.get(
    `/Doctors/GetSuggestedDoctors?${new URLSearchParams(body)}`,
  );
  return response.data;
};

export const getOnlineSuggestedDoctorList = async (
  body: GetOnlineSuggestedDoctorsPayload,
): Promise<GetOnlineSuggestedDoctorsResponse> => {
  const response: any = await request.get(
    `/Doctors/GetOnlineSuggestedDoctors?${new URLSearchParams(body)}`,
  );
  return response.data;
};

export const getDoctorProfile = async (
  id: number,
): Promise<DoctorProfileResponse> => {
  const response = await request.get(`/Doctors/GetDoctorById?Id=${id}`);
  return response.data;
};

export const getDoctorReviews = async (
  body: any,
): Promise<DoctorReviewsData> => {
  const response = await request.get(
    `/Doctors/GetDoctorReviews?${new URLSearchParams(body)}`,
  );
  return response.data;
};

export const GetDoctorActivityStatus = async (
  id: number,
): Promise<DoctorActivityResponseModel> => {
  const response = await request.get(
    `/Doctors/GetDoctorActivityStatus?Id=${id}`,
  );
  return response.data;
};

export const getDoctorServiceTarifs = async (
  id: number,
  specialityId: number,
  systemType: number,
  hasSchedule: boolean,
): Promise<DoctorServiceTarifsDataModel> => {
  const response = await request.get(
    `/Doctors/GetServiceTarifs?Id=${id}&SpecialityId=${specialityId}&SystemType=${systemType}&HasSchedule=${hasSchedule}`,
  );
  return response.data;
};

export const notifyOnlineDoctor = async (
  data: NotifyOnlineDoctorPayload,
): Promise<NotifyOnlineDoctorResponse> => {
  const response = await request.post(`/Doctors/Notify`, data);
  return response.data as NotifyOnlineDoctorResponse;
};
